import { Dropdown } from "primereact/dropdown";
import { FloatLabel } from "primereact/floatlabel";
import { InputMask } from "primereact/inputmask";
import { InputNumber } from "primereact/inputnumber";
import { useEffect, useState } from "react";
import { countries } from "./countryList";
import { countriesTurkish } from "./countryListTurkish";

const PhoneNumber = ({
    phoneNumber,
    phoneNumberError,
    codeForPhoneNumber,
    setCodeForPhoneNumber,
    handleCredentials,
    t,
    region
}: any) => {
    const [countyList, setCountyList] = useState<any>()

    const phoneNumberMask = () => {
        switch (region) {
            case 'TR':
                return <InputMask invalid={!!phoneNumberError} mask="(599) 999 99 99" name="phoneNumber" className='p-inputtext-lg w-full' variant="filled" id='phoneNumber' value={phoneNumber} onChange={(e) => handleCredentials(e)} />
            default:
                return <InputNumber invalid={!!phoneNumberError} name="phoneNumber" className={'p-inputtext-lg w-full'} useGrouping={false} value={phoneNumber} onChange={(e) => handleCredentials(e)} />
        }
    }

    const toTitleCase = (str: any) => {
        return str.charAt(0).toUpperCase() + str.slice(1);
    }

    const selectedCountryTemplateForPhone = (option: any, props: any) => {
        if (option) {
            return (
                <div className="flex align-items-center">
                    <img alt={option.name}
                        src={`https://flagcdn.com/w20/${option.code.toLowerCase()}.png`}
                        className={`mr-2 flag flag-${option.code.toLowerCase()}`} style={{ width: '20px', borderRadius: "12px" }} />
                    <p className='m-0'>{option.phoneCode}</p>
                </div>
            );
        }

        return <span>{props.placeholder}</span>;
    };

    const countryOptionTemplateForPhone = (option: any) => {
        return (
            <div className="flex align-items-center">
                <img alt={option.name} src={`https://flagcdn.com/w20/${option.code.toLowerCase()}.png`} className={`mr-2 flag flag-${option.code.toLowerCase()}`} style={{ width: '20px', borderRadius: "12px" }} />
                <div>{toTitleCase(option.name)}</div>
                <div className='ml-2'>{option.phoneCode}</div>
            </div>
        );
    };

    useEffect(() => {
        localStorage.getItem("i18nextLng") === "en"
            ? setCountyList(countries)
            : setCountyList(countriesTurkish)
        localStorage.getItem("i18nextLng") === "en"
            ? setCodeForPhoneNumber({ name: 'türkiye', code: 'TR', phoneCode: '+90' })
            : setCodeForPhoneNumber({ name: 'türkiye', code: 'TR', phoneCode: '+90' })
    }, [t])

    const handleDropdown = (e:any) => {
        setCodeForPhoneNumber(e.target.value);
    }

    return (
        <div className="flex align-items-start justify-content-center w-full gap-2">
            <Dropdown style={{ height: '3.875rem', width: '10rem', display: "flex", justifyContent: "center", alignItems: "center" }} value={codeForPhoneNumber} options={countyList} optionLabel="name"
                    valueTemplate={selectedCountryTemplateForPhone} itemTemplate={countryOptionTemplateForPhone}
                    onChange={e => { setCodeForPhoneNumber(e.target.value); handleDropdown(e) }} filter filterMatchMode='startsWith' />
            <div className="flex-1">
                <FloatLabel>
                    {phoneNumberMask()}
                    <label htmlFor='phoneNumber'>{t('phoneNumber')}</label>
                </FloatLabel>
                {(!!phoneNumberError) && <small className='text-red-500 text-xs'>{t(phoneNumberError)}</small>}
            </div>
        </div>
    )
}

export default PhoneNumber;